import Vue from 'vue'
import Index from './index.vue'
import "babel-polyfill";
import store from '@/store/index.js'
import { getQueryString } from '@/scripts/util.js'
import { bpoTip } from '@/scripts/bpo.js'

Vue.config.productionTip = false
Vue.prototype.$toast = bpoTip;
Vue.prototype.$query = getQueryString;
new Vue({
    render: h => h(Index),
    store
}).$mount('#app')